<!--  -->
<template>
<div style="width:98%;height:90%;border:none" class=''>
  <el-upload
  class="upload-demo"
  ref="uploadVideo"
  style="display:inline-block;width:30%;height:40%;"
  :on-change="handleChange"
  :on-success="uploadSuccess"
  :on-error="uploadError"
  :show-file-list="false"
  :multiple="false"
  :headers="myHeaders"
  :action="uploadVideo"
  :auto-upload="false">
    <video slot="trigger" style="cursor: pointer;width:100%;height:100%;box-shadow: 0 4px 20px rgba(19,96,150,0.12);object-fit:fill;border-radius: 12px;opacity: 0.95;" autoplay="autoplay" loop="loop" muted="muted" :src="movieFile"></video>
    <el-button v-show="ifSaveVideo" @click="saveVideo" style="display:block;margin-top:8px" size="small" type="primary" >保存</el-button>
  </el-upload>
  <div class="cView" @click="cView($event)">
    <div class="front">
      <div style="width:100%;height:18%;display:inline-block;font-size:20px;color:#173247;padding:0 16px;box-sizing:border-box;border-bottom:1px solid rgba(54,174,232,0.16);font-weight:700">
        <div style="height:100%;display:table;margin:0 auto">
        <span style="height:100%;vertical-align:middle;display:table-cell">
          当日访问量: <span style="color:#1b9ad9;font-weight:800">{{ viewData.totalNum }}</span>
        </span>
        </div>
      </div>
      <div style="width:100%;height:82%;display:inline-block" id="userView"></div>
    </div>
    <div class="back">
     
    </div>

    <!-- <div style="width:100%;height:80%;color:white;font-size:40px;display:inline-block">
      <div style="height:100%;display:table;margin:0 auto">
       <span style="height:100%;vertical-align:middle;display:table-cell">
        123
      </span>
      </div>
    </div> -->
  </div>
  <div class="cView" @click="cView($event)">
    <div class="front">
      <div style="width:100%;height:18%;display:inline-block;font-size:20px;color:#173247;padding:0 16px;box-sizing:border-box;border-bottom:1px solid rgba(54,174,232,0.16);font-weight:700">
      <div style="height:100%;display:table;margin:0 auto">
       <span style="height:100%;vertical-align:middle;display:table-cell">
        当日模块访问量
      </span>
      </div>
      </div>
      <div style="width:100%;height:82%;display:inline-block" id="modelView">
      </div>     
    </div>
    <div class="back">
      
    </div>
  </div>
  <!-- <div style="height:40%;width:30%;display:inline-block;border:1px solid black;vertical-align: top;margin-left:3.5%;border-radius:10px;background-color: rgba(0, 0, 0,0.8);box-shadow: 0 0 10px black;">
    <div style="width:100%;height:20%;color:rgb(249, 248, 248);display:inline-block;font-size: 20px;border-bottom:2px double rgb(252, 249, 249)">
      <div style="height:100%;display:table;margin:0 auto">
       <span style="height:100%;vertical-align:middle;display:table-cell">
        周访问人次曲线图
      </span>
      </div>
    </div>
    <div style="width:100%;height:80%;color:white;font-size:40px;display:inline-block">
      <div style="height:100%;display:table;margin:0 auto">
       <span style="height:100%;vertical-align:middle;display:table-cell">
        123
      </span>
      </div>
    </div>
  </div> -->
</div>
</template>

<script>
import * as echarts from 'echarts';
import userInfo from '@/api/admin/userInfo.js'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {applicationName} from '@/utils/const.js'
import { getToken} from '@/utils/auth'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  movieFile:process.env.VUE_APP_HOME_VIDEO_URL,
  viewData:{
    pN : [], //展示每个省份的名称集合
    pV : [], //展示每个省份人数集合
    totalNum:0,//页面访问人总数
    mN : [], //展示每个模块名称集合
    mV : [] //展示每个模块访问人数集合
  },
  ifSaveVideo:false,
  movieData:"",
  uploadVideo:`${process.env.VUE_APP_API_URL+applicationName}/admin/file/upload/homeVideo`,
  myHeaders:{
    Authorization:getToken()
  },
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  cView(e){
    var card = e.currentTarget
    card.classList.toggle('flipped')
  },
  initModelView(){
    var _this = this
    var modelV = document.getElementById("modelView")
    userInfo.viewModelNum().then(({data})=>{
      var keys = Object.keys(data)
      console.log("key",data)
      keys.forEach((key)=>{
        switch(key){
          case "brandInfo": _this.viewData.mN[0]="品牌资讯";_this.viewData.mV[0] = data[key];break;
          case "company": _this.viewData.mN[1] = "公司简介";_this.viewData.mV[1] = data[key];break;
          case "corporateImage": _this.viewData.mN[2] = "形象大片";_this.viewData.mV[2] = data[key];break;
          case "franchise": _this.viewData.mN[3] = "加盟信息";_this.viewData.mV[3] = data[key];break;
        }
      })
      var myModelV = echarts.init(modelV)
      var option = {
          xAxis: {
            type: 'category',
            data: _this.viewData.mN
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: _this.viewData.mV,
              type: 'bar',
              itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#51c7f4' },
                { offset: 1, color: '#1b9ad9' }
              ]),
              barBorderRadius: 5,
              borderWidth:1,
              borderType:"solid",
              shadowColor: 'rgba(27, 154, 217, 0.3)',
              shadowBlur: 4,
              opacity: 0.88
              }
            }
          ]
        };
        option&myModelV.setOption(option);
    })
  },
  initUserView(){
     var _this = this
     var userV = document.getElementById("userView")
     userInfo.viewUserNum().then(res=>{
       var data = res.data
       var keys = Object.keys(data)
       var province = {}//用于存入省份数据

       //提取传入对象属性 total为总数据 其他为省份数据
       for(var key in keys){ 
        if(keys[key] == "total"){
          _this.viewData.totalNum = data[keys[key]]
        }else{
          province[keys[key]] = data[keys[key]]
        }
       }
       //只显示前5名的省份信息
       _this.viewData.pN = Object.keys(province).slice(0,5)
       _this.viewData.pN.sort((v1,v2)=>{
        return province[v1] - province[v2]
       })

       for(var i=0;i<_this.viewData.pN.length;i++){
        _this.viewData.pV.push(province[_this.viewData.pN[i]])
       }

       var myUserV = echarts.init(userV)
       var option = {
            xAxis: {
              type: 'category',
              data: _this.viewData.pN
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                data: _this.viewData.pV,
                type: 'bar',
                itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#51c7f4' },
                  { offset: 1, color: '#1b9ad9' }
                ]),
                barBorderRadius:5,
                shadowColor: 'rgba(27, 154, 217, 0.3)',
                borderType: 'dashed',
                opacity: 0.88
                }
              }
            ]
          };
        option&myUserV.setOption(option);
     })
  },
  uploadSuccess({data}){
    this.$message.success("首页视频保存成功")
    this.ifSaveVideo=false
    this.movieFile=`${process.env.VUE_APP_API_URL+applicationName}/${data.url}`
  },
  uploadError(){
    this.$message.error("首页视频保存失败")
  },
  saveVideo(){
     this.$refs.uploadVideo.submit();
  },
  handleChange(file){
  var _this = this;
   const reader = new FileReader();
   reader.onload = function(){
    _this.movieFile = reader.result
    _this.ifSaveVideo = true
    _this.movieData = file
    console.log(_this.movieData)
   }
   reader.readAsDataURL(file.raw)
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  // window.location.reload()

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.initUserView()
  this.initModelView()
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
/** scoped 表示 样式只在当前组件有效 */
//@import url(); 引入公共css类
.upload-demo div{
  width:100%;
  height:100%;
}
.cView{
  height:40%;
  width:30%;
  display:inline-block;
  vertical-align: top;
  margin-left:3.5%;
  transform-style: preserve-3d;
  transition:1s;
  perspective: 1000px;
}
.front{
  width:100%;
  height:100%;
  border-radius:12px;
  background: #fff;
  border: 1px solid rgba(54, 174, 232, 0.16);
  box-shadow: 0 8px 24px rgba(19, 96, 150, 0.08);
}
.back{
  width:100%;
  height:100%;
  border-radius:12px;
  border: 1px solid rgba(54, 174, 232, 0.16);
  box-shadow: 0 8px 24px rgba(27, 154, 217, 0.12);
  background: #e8f7ff;
  backface-visibility: hidden;
  transform: rotateY(180deg);
}
.front,.back{
  position:absolute;
  cursor: pointer;
}
.flipped {
    transform: rotateY(180deg);
}
</style>